<template>

   <spinner v-if="!loaded" ></spinner>

    <div class="template-padding container" v-else-if="loaded"  > 
        
        <div class="row" >
            <div class="col-12 text-left" >
                <router-link :to="{name: 'Facebook Ads Masterclass' }" class="not-active text-left btn btn-transparent border-none btn-sm" > 
                    <font-awesome-icon icon="arrow-circle-left" ></font-awesome-icon> Back 
                </router-link>
            </div>
        </div>
        
        <div class="col-12 col-md-10 offset-md-1 p-0 mt-3" >
            <img src="@/assets/images/facebook_ads_masterclass_1200x628-01.png" class="w-100" />
        </div>
        
        <div class="text-justify mt-5 mb-3 h3" style="line-height: 1.5;" >

        </div>
        
        <!-- ACADEMY -->
        <div class="accordion mt-5" role="tablist">
            
            <!-- INTRO -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-0 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        1. Creatives
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            <span id="accordion0" > {{ calculateRead('accordion0') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-0"  accordion="my-accordion" role="tabpanel" class="p-3" >
                    <b-card-body ref="accordion0" >
                        
I want to start with the images or the ad creatives as it’s the most important part. This is the first thing people see when they scroll their feed and will dictate if they will stop and read the copy or scroll away.
<br><br>
With social media and the latest trends, the attention span has decreased significantly.
<br><br>
We are getting more and more used to getting condensed information in the form of short tweets or 14 second videos.
<br><br>
So getting the reader’s attention is getting harder and harder.
<br><br>
That’s why ad creative is the most important part. Having great creatives will grab people’s attention and invite them to read the copy.
<br><br>
This is the part where your creative part must kick in. Also, it might be a good idea to reach out to a graphic designer to help you create stunning images.
<br><br>
Even though Facebook has a library of stock images that can be used, I would advise against it as they could be perceived as fake.
<br><br>
Also, videos work great. As well as testimonials.Use testimonial ads whenever possible, especially in video formats.
<br><br>
When asking your clients for testimonials, ask them to record a quick video and take parts of that video and use it as ad copy.
<br><br>
Another great way is to have your headline written in an image and use it as the creative. If you have a great hook, it can work wonders.
<br><br>
Make sure to use bright colours that are pleasing to the eye but get attention.

                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- INTRO -->
            
            <!-- Structure -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-1 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        2. The Hook
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            <span id="accordion1" > {{ calculateRead('accordion1') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-1"  accordion="my-accordion" role="tabpanel" class="p-3" >
                    <b-card-body ref="accordion1">
                        
Regardless of whether you use the hook in your creative or not, it will be the first element they see, the first line of your ad, before they click see more.
<br><br>
You have less than 5 seconds to get someone’s attention on Facebook and keep them reading your ad until they scroll away and never come back.
<br><br>
The first couple of lines are all people see when scrolling: the image, the hook and sometimes  a couple of lines, depending on how long the first line is.
<br><br>
The hook’s job is to get attention and cast the reader into the story. Make sure to include a:
<br> - Core message / benefit
<br> - Unique mechanism
<br> - Big promise
<br> - Testimonial ( the best sentence from a testimonial )
<br> - Interesting statistic / fact
<br> - Curiosity provoking
<br><br>
For more, check out the headline section from our copywriting masterclass to get insights and examples on how to create them.
<br><br>
More examples of winning hooks:
<br><i> Learn how to Create High-Converting Sales Pages in Only 7 Days! </i>
<br><i> Grow Your Sales in 30 Days or I’ll Give you your Money Back</i>
<br><i> Get the [product name] & Over $1000 in Bonuses</i>
<br><i> 5126 Entrepreneurs Can’t Be Wrong! Get Access to [product] for 50% Off</i>
<br><br>
Another great strategy is to <strong>call out your avatar</strong> in the first line:
<br><i> Attention Entrepreneurs: are you looking for new ways to grow your business?</i>
<br><i> This is for entrepreneurs that are looking to grow their sales using paid ads.</i>

                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- Structure -->
                    
            <!-- Structure -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-2 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        3. The Ad Copy
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            <span id="accordion2" > {{ calculateRead('accordion2') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-2"  accordion="my-accordion" role="tabpanel" class="p-3" >
                    <b-card-body ref="accordion2">
                        
When writing your ad copy, make sure you know these key things.
<br><br>
Always put your audience or avatar first. Call them out and speak directly to them, speak their language.
<br><br>
Speak to them like a trusted friend or advisor and highlight pain points and frustrations. Empathise with their pain and current situation and then turn it smoothly into a solution. 
<br><br>
Put them in the frame of mind that you’ve figured out something they can’t ( yet ) or have something they want and need.
<br><br>
Know who you are selling to and talk about their pain points and how you can fix them. Don’t talk about your product features, people don’t want to hear that. 
<br><br>
They are interested in how you can make their lives better or fix their problems. We are emotional beings and we buy based on emotion.
<br><br>
Call attention to their role, occupation, without saying “you”. You must always be compliant with Facebook’s standards. 
<br><br>
For example:
<br><strong>Compliant</strong>: This is for entrepreneurs who keeps losing money on Facebook ads.
<br><strong>Not compliant</strong>: Are you an entrepreneur who keeps losing money on Facebook ads?
<br><br>
Try to avoid calling them out in a negative way, like a way they might feel bad.
Instead of saying “Need to lose the last 10 pounds” or “hate the way you look?” you can try saying “You know that losing the last 10 pounds is hard” or “this is for people who just can’t get the scale to budge”.
<br><br>
I’m using health examples as this industry is very tough and most disapprovals and issues are in this particular niche.
<br><br>
There are hundreds of ways you can create your copy. You can use short copy, long copy, paragraphs vs bullet points.
<br><br>
The best strategy is to test multiple variations of copy and find a winner.
<br><br>
Running ads is not a guessing game, it’s a constant optimization process. It’s a number’s game.
<br><br>
For more details on how to actually create your copy, check out our copywriting masterclass.

                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- Structure -->
                    
            <!-- Structure -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-3 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        4. Call To Action ( CTA )
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            <span id="accordion3" > {{ calculateRead('accordion3') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-3"  accordion="my-accordion" role="tabpanel" class="p-3" >
                    <b-card-body ref="accordion3">
                        
A good strategy is to write your headline as a Call To Action and use that. The headline is clear, strong and bold, so why not use it as a CTA?
<br><br>
It helps prompt the reader to take action now, lets them know exactly what to expect if they click and gives them exactly what they want if done right.
<br><br>
It should be the same as the first hook.

                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- Structure -->
                    
            <!-- Structure -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-4 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        Key Takeaways
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            <span id="accordion4" > {{ calculateRead('accordion4') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-4"  accordion="my-accordion" role="tabpanel" class="p-3" >
                    <b-card-body ref="accordion4">
                        
In order to find winning ads, you need to test a lot of them. This way, it gives the algorithm a lot of data to work with and will let your audience figure out what they like best so you can identify trends and patterns.
<br><br>
This will also bring down CPA over time.
<br><br>
<strong>So what to test?</strong>
There are a lot of ads you can test, depending on your product and audience.
<br><br>
<strong>Long form copy</strong>,  blog style copy consisting of  +300 words work better especially for high-ticket offers. The higher the price, the harder the persuasion and the longer the copy.
<br><br>
Long form copy can also be used to teach people about something or to drive them to an advertorial. Works better for cold traffic.
<br><br>
<strong>Short, standard and direct copy</strong> works better for e-commerce and low ticket, as that doesn’t need much convincing.
<br><br>
3 line ads that go straight to the point are good for e-commerce and retargeting warm leads. 1 line ads work great as well, when used for e-commerce sales or when you have a strong creatives that does the selling.
<br><br>
Have different variations of the same copy, but displayed in different formats. For example, you can take the long copy and write it as paragraphs in one ad and as bullet points in another.
<br><br>
Test different copywriting frameworks: AIDA, PAS or PaP. See the copywriting masterclass for more details on that.
If you have an offer that might not be compliant or you are having a hard time making it compliant, try a first person story, when you talk about a pain point you were having and finally find a solution.
<br><br>
Testimonial ads work great for any form of traffic. Video testimonials with a written version can work wonders.
 <br><br>
Carousel ads are great for e-commerce products.
<br><br>
Video or slideshow ads are great for e-commerce products as well as for high-tickets offers.
<br><br>
Start with 5 ads then slowly launch new ones until you find winners.
<br><br>
Now let’s dive into the ads manager and create a campaign.

                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- Structure -->
        
          </div>
        <!-- ACADEMY -->

        
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import axios from 'axios'
    
export default{
    name: "ACADEMY_sales_page",
    props:["APPKEY"],
    components:{
    },
    data () {
        return {
            loaded: false,
            text: `
              Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
              richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor
              brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
              tempor, sunt aliqua put a bird on it squid single-origin coffee nulla
              assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore
              wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
              vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic
              synth nesciunt you probably haven't heard of them accusamus labore VHS.
            `
        }
    },
    mounted(){
        this.loaded = true;
    },
    methods:{
        openRow(params){
            
            let user =  Cookies.get('user')
            user = JSON.parse( atob( user ) )
            
            let page = params.row.Icon;
            let ID = params.row.ID;
            
            
            
            
        },
        returnDate(a){
            //return this.$moment.unix(a).format( 'MMM D, HH:mm' )
            return helper.formatDate( a, 'MMM D, HH:mm' )
        },
        
        calculateRead( target ){
            
            //console.log( ev )
            setTimeout( function(){
                
                //console.log( this.$refs )
                //console.log( this.$refs[target].innerHTML )                
                
                let ev = this.$refs[target].innerHTML
                
                const wordsPerMinute = 150; // Average case.
                let result;
                
                let textLength = ev.split(" ").length; // Split by words
                if(textLength > 0){
                    let value = Math.ceil(textLength / wordsPerMinute);
                    result = `~${value} min read`;
                }
                //return result
                //this.$refs[target].appendChild( result )
                document.getElementById(target).innerHTML = result;
                
            }.bind(this), 400 )
                
        }
    },
    computed: {

    },
    created: function () {

    },
    
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/templates/Academy/courses/facebook-ads-masterclass/03.vue